import React from 'react';

import BillingSubscriptionPageContent
  from 'components/dashboard/billing-content/BillingSubscriptionPageContent';

const BillingSubscriptionPage = () => <BillingSubscriptionPageContent />;

export default BillingSubscriptionPage;
